export default __webpack_public_path__ + "static/media/RO.464ade15.svg";